import { useCallback, useState } from "react";

/** Dónde se recuerda que la barra quedó plegada. */
export const SIDEBAR_COLLAPSED_KEY = "nh.sidebar.collapsed";

function readStored(): boolean {
  try {
    return window.localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === "1";
  } catch {
    // Safari en privado y los navegadores con el almacenamiento bloqueado
    // LANZAN al leer. Una preferencia de cromo no puede tumbar la app.
    return false;
  }
}

/**
 * Si la barra lateral está plegada, recordado entre visitas.
 *
 * El valor inicial se lee dentro del inicializador perezoso de
 * `useState` —no en un `useEffect`— para que el primer pintado ya salga
 * plegado. Con un efecto, quien la dejó plegada vería la barra completa
 * un fotograma y luego encogerse: el salto es más molesto que la propia
 * preferencia.
 */
export function useSidebarCollapsed(): [boolean, () => void] {
  const [collapsed, setCollapsed] = useState<boolean>(readStored);

  const toggle = useCallback(() => {
    setCollapsed((current) => {
      const next = !current;
      try {
        window.localStorage.setItem(SIDEBAR_COLLAPSED_KEY, next ? "1" : "0");
      } catch {
        // Se pierde la preferencia, no la sesión. Sigue funcionando.
      }
      return next;
    });
  }, []);

  return [collapsed, toggle];
}
